import { Component } from 'react';
import PropTypes from 'prop-types';
import { loadModules } from 'react-arcgis';

class MapImageLayer extends Component {
  componentDidMount() {
    const { view } = this.props;

    loadModules(['esri/layers/MapImageLayer']).then(([MapImageLayer]) => {
      this.layer = new MapImageLayer({
        url: this.props.url,
        opacity: 0.5 // makes ZIP layer semi-transparent so it overlays nicely
      });
      view.map.add(this.layer);
    });
  }

  componentWillUnmount() {
    const { view } = this.props;
    if (view && this.layer) {
      view.map.remove(this.layer);
    }
  }

  render() {
    return null;
  }
}

MapImageLayer.propTypes = {
  url: PropTypes.string.isRequired,
  view: PropTypes.object.isRequired
};

export default MapImageLayer;